'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Up = require('./Up');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Up).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/fontAwesome/Up/index.js
// module id = 1093
// module chunks = 1